package songwritersnotebook.app.platform

import androidx.compose.runtime.Composable

@Composable
actual fun PlatformAdView() {
    // No-op on JS
}
